import type { TroubleshootingItem } from '../../types/careExpanded';

interface TroubleshootingSectionProps {
  items: TroubleshootingItem[];
}

export function TroubleshootingSection({ items }: TroubleshootingSectionProps) {
  if (items.length === 0) {
    return (
      <p className="text-sm text-gray-500 italic">No troubleshooting info available</p>
    );
  }

  return (
    <div className="space-y-3">
      {items.map((item, index) => (
        <div
          key={index}
          className="p-4 rounded-lg bg-background border border-gray-200"
        >
          {/* Symptom */}
          <div className="flex items-start gap-2 mb-2">
            <span className="text-amber-500 mt-0.5" aria-hidden="true">⚠️</span>
            <h4 className="font-medium text-editorial-black">{item.symptom}</h4>
          </div>

          {/* Cause */}
          <div className="ml-6 mb-2">
            <dt className="text-xs font-medium uppercase tracking-wide text-gray-500">
              Likely Cause
            </dt>
            <dd className="mt-0.5 text-sm text-editorial-black">{item.cause}</dd>
          </div>

          {/* Fix */}
          <div className="ml-6 p-2 rounded bg-green-500/5 border border-green-500/10">
            <dt className="text-xs font-medium uppercase tracking-wide text-green-600">
              Solution
            </dt>
            <dd className="mt-0.5 text-sm text-editorial-black">{item.fix}</dd>
          </div>
        </div>
      ))}
    </div>
  );
}
